module.exports = __webpack_public_path__ + "static/urban2-33206dfad04796f2e21f598d708ba476.jpg";